import { reduxStoreTypes } from '@type/redux-store';

export const SET_MEMBER_DETAIL: reduxStoreTypes.MemberDetailType = 'SET_MEMBER_DETAIL';
export const setMemberDetail = (params: Omit<reduxStoreTypes.MemberDetailAction, 'type'>) => ({
    type: SET_MEMBER_DETAIL,
    ...params
})